// extracted by mini-css-extract-plugin
export default {"root":"EditListingLanguagesPanel_root__Gr2e5","form":"EditListingLanguagesPanel_form__VVXHx","title":"EditListingLanguagesPanel_title__84A30"};